export default __webpack_public_path__ + "static/media/FAskg8JVgAQzBIe.bfe38521.jpg";